var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-bar-wrap"},[_c('input',{staticClass:"search-bar",attrs:{"type":"text","autocomplete":_vm.autocomplete,"name":"search","placeholder":_vm.$t('search')},domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }